import { Drawer } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import React, { useEffect, useState } from "react";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
// import List from '../../Assets/images/listing.png'
import Button from "../SelectValue/Button";
import getServices from "../../Services/get-service";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../SelectValue/Loading";
import BuyUnits from "./Buyunit";
import Constant from "../../Constant";
import ImageSlider from "./ImageSlider.js";
const drawerWidth = 650;

function ListPropertyDrawer({
  open,
  handleClose,
  window: windowProp,
  id,
  details,
}) {
  const [projectDetails, setProjectDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [opens, setOpen] = useState(false);
  const handleOpens = () => setOpen(true);
  const handleCloses = () => setOpen(false);
  useEffect(() => {
    if (details) {
      setProjectDetails(details);
      
      let imgs = [];
      if (Array.isArray(details.projectImages)) {
        imgs = details.projectImages.map((img) => img.imageUrl || img).filter(Boolean);
      } else if (Array.isArray(details.imageUrl)) {
        imgs = details.imageUrl;
      } else if (typeof details.imageUrl === 'string') {
        imgs = [details.imageUrl];
      } else if (typeof details.projectImages === 'string') {
        imgs = [details.projectImages];
      }
      setImages(imgs);
    }
  }, [details]);

  return (
    <div>
      <Drawer
        anchor="right"
        variant="temporary"
        open={open}
        onClose={handleClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: { xs: "100%", sm: drawerWidth },
            backgroundColor: "white",
          },
        }}
      >
        <div>
          <BuyUnits
            open={opens}
            handleClose={handleCloses}
            closeDrawer={handleClose}
            number={1}
            id={projectDetails.propertyId}
            amount={projectDetails.price}
            type="property"
            details={projectDetails}
          />
          <Loading open={loading} />
          <div className=" p-4 border-b border-b-[#808285] flex justify-between">
            <p className=" text-back-color2 capitalize text-[18px] pt-3">
              {projectDetails.title} property for sale
            </p>
            <div className="pt-2">
              <CancelIcon
                onClick={handleClose}
                className=" text-back-color2 text-[38px]"
                fontSize="large"
              />
            </div>
          </div>
          <div className=" px-4 pt-2">
            <div className=" flex justify-between ">
              <div>
                <p className=" text-primary-color mb-2 text-[14px] capitalize font-[500]">
                  {projectDetails.projectName}
                </p>
                <p className=" text-back-color2 font-[500] capitalize text-[14px]">
                  <PlaceOutlinedIcon /> {projectDetails.locality}
                </p>
              </div>
              <div>
                <p className=" text-back-color2 font-[400] text-[14px]">
                  {" "}
                  <span className=" text-primary-color font-[500] text-[24px]">
                    NGN {Constant.FormatNumber(projectDetails.price)}{" "}
                  </span>
                </p>
              </div>
            </div>
            <div className=" my-3">
              <ImageSlider imageList={images} />
            </div>
            <div className=" my-5">
              <Button
                name="Finance this property"
                bool={true}
                onClick={handleOpens}
              />
            </div>
            <div className=" my-5">
              <p className=" font-[400] text-back-color2 text-center text-[16px]">
                Interested in this property?
              </p>
              <div className=" mt-2 gap-3 flex justify-center">
                <p className="font-[500] text-[16px] pt-2">
                  <span className="font-[400] text-[16px] ">Call :</span> {projectDetails.phoneNumber || "0817 XXXXX"}
                </p>
                <Button name="Show phone" />
              </div>
            </div>
            <div>
              <div className="mt-4">
                <p className="text-[#1E222B] text-[15px] font-[600] mb-2">Description</p>
                <p className="text-back-color2 text-[14px] leading-relaxed">
                  {projectDetails.description || "No description provided."}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
}

export default ListPropertyDrawer;
